export const environment = {
  production: false,
  hostUrl: 'https://comvezcol-be.procesapp.com/api/',
  host: 'https://comvezcol-be.procesapp.com',
};
